import { COLOR_PALETTE } from 'constants/ui';
import { getConditionalObject } from 'utils/data';

// Light: the master-menu popover sits on the brand-blue surface, so each entry is a contained brand-blue
// button (blue-on-blue, active deepens to primary.dark). On the DARK popover that blue fill is glaring on
// every item, so in dark they become transparent text rows on the dark panel: text.primary label, a
// low-alpha accent tint on hover, and a stronger accent tint when active (consistent with the other dark
// header/menu surfaces).
const getActiveItemBackground = palette =>
  palette.mode === 'dark' ? palette.primary.extraSoft : palette.primary.dark;

export const getButtonStyles = ({ isVertical }) => ({
  display: 'grid',
  gridTemplateColumns: 'auto 1fr auto',
  gap: '8px',
  textAlign: 'start',
  width: '100%',

  '&[data-is-active="true"]': {
    backgroundColor: ({ palette }) => `${getActiveItemBackground(palette)} !important`,
  },

  ...getConditionalObject(!isVertical, {
    color: ({ palette }) =>
      palette.mode === 'dark' ? `${palette.text.primary} !important` : undefined,
    backgroundColor: ({ palette }) =>
      palette.mode === 'dark' ? 'transparent !important' : undefined,

    '&:hover': {
      backgroundColor: ({ palette }) =>
        palette.mode === 'dark' ? `${palette.primary.soft} !important` : undefined,
    },
  }),

  ...getConditionalObject(isVertical, {
    color: ({ palette }) => `${palette.text.dark} !important`,
    backgroundColor: 'transparent !important',

    '&:hover': {
      backgroundColor: `${COLOR_PALETTE.BRAND[1]} !important`,
    },

    '&[data-is-active="true"]': {
      color: ({ palette }) => `${palette.text.link} !important`,
      backgroundColor: `${COLOR_PALETTE.BRAND[1]} !important`,
    },
  }),
});
